import React from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import { animations } from "react-animation";
import "./FeaturesBox.css";

FeaturesBox.propTypes = {
  titulo: PropTypes.string,
  imagenUrl: PropTypes.string,
  featUrl: PropTypes.string,
  titlePos: PropTypes.string, //top, middle
  descripcion: PropTypes.string,
  footerNote: PropTypes.string,
  showMoreInfoButton: PropTypes.bool,
  moreInfoButtonText:PropTypes.string 
};

function FeaturesBox({
  titulo,
  imagenUrl,
  featUrl,
  titlePos = "middle",
  descripcion,
  footerNote,
  showMoreInfoButton,
  moreInfoButtonText="Más Información",
  ...props
}) {
  const onErrorImage = (text) => {
    var texto = text.substr(0, 6);
    return "http://placehold.jp/00bab4/ffffff/800x600.png?text=" + texto;
  };

  const openUrl = () => {
    window.open(featUrl, "_blank");
  }

  return (
    <>
      {titlePos === "top" && (
        <div
          className="container-feature"
          style={{ animation: animations.fadeIn }}
        >
          <div className="feature-summary-card">
            <div className={`feature-image feature-image-${titlePos}`}>
              <div
                className={`feature-image-title feature-image-title-${titlePos}`}
              >
                {titulo}
              </div>
              <img
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = onErrorImage(titulo);
                }}
                src={imagenUrl}
                alt={titulo}
              />
              <div
                className={`feature-image-title feature-image-subtitle-${titlePos}`}
              >
                {Parser(descripcion)}
              </div>             

            </div>
          </div>
        </div>
      )}
      {titlePos === "middle" && (
        <div
          className={`container-feature container-feature-${titlePos}`}
          style={{ animation: animations.fadeIn }}
        >
          <div className="feature-summary-card">
            <div className={`feature-image feature-image-${titlePos}`}>
              <div className="feature-image-container">
                <img
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = onErrorImage(titulo);
                  }}
                  src={imagenUrl}
                  alt={titulo}
                />
              </div>
              <div
                className={`feature-image-title feature-image-title-${titlePos}`}
              >
                {titulo}
              </div>
            </div>

            <div className="feature-description">{Parser(descripcion)}</div>
            {showMoreInfoButton && (
              <div className="feature-btn-more-info">
                <button className="feature-button" onClick={() => openUrl()}>
                  {moreInfoButtonText}
                </button>
              </div>
            )}
            {footerNote && (
              <div className="feature-footer">
                <small>{footerNote}</small>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default FeaturesBox;
